import Vue from 'vue'
import { inDev } from '@/util/env.js'
import '@/styles/global.less'
// 加载 element 组件库
import ElementUI from 'element-ui'

// 加载 element 组件库的样式
import 'element-ui/lib/theme-chalk/index.css'

// 全局注册 element 组件库
Vue.use(ElementUI)

// import App from './App.vue'
import router from './router'
import store from './store'

import App from "@/App.vue";
import Breadcrumb from '@/views/components/Breadcrumb.vue'

Vue.component('Breadcrumb', Breadcrumb)

import videoPlayer from './components/media/videoPlayer/index.js';

Vue.prototype.$videoPlayer = videoPlayer;
//是否在审核环境
window._IN_FM_AUDIT_ENV_ = false

Vue.config.productionTip = false
Vue.prototype.inDev = inDev
// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')
window.env = 'FM_PC'
const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.vm = vm
